<div class="search-table">
    <div class="search-row">
        <span ng-if="advancedSearchQuery" class="search-property" c-select options="advancedSearchPropertyOptions" selected-option="advancedSearchPropertySelected"></span>
        <input type="text" autocomplete="off" class="search-box-input" ng-model="searchQuery" c-focus-on="searchBox" placeholder="{{'searchQuery'|translate}}" />
        <i class="fa fa-search search-button" ng-click="search()"></i>
    </div>
</div>
<div class="search-auto-complete" ng-show="showAutoComplete">
    <ul c-hit-highlight="myFilter">
        <li class="previous-search" ng-repeat="item in previousFiltered = (previousSearches | filter: myFilter)" ng-click="setQuery(item)" ng-class=" {'selected': $index == selectedIndex}" data-value="{{item}}">
            <span>{{item}}</span>
            <a ng-click="removeQuery(item)" data-translate="delete"></a>
        </li>
        <li ng-repeat="item in searchMetadata | cDuplicate: previousFiltered" ng-class="{'selected': $index + previousFiltered.length == selectedIndex}" ng-click="setQuery(item)" data-value="{{item}}">
            <span>{{item}}</span>
        </li>
    </ul>
</div>